import { type JwtPayload } from 'jwt-decode';

import { getDecodedJwt } from '@/utils/getDecodedJwt';

export interface JwtToken extends JwtPayload {
  atype: 'anonymous' | 'identity';
  mvpdid: string;
}

export function isMvpdAuthenticated(accessToken?: string): boolean {
  if (!accessToken) {
    return false;
  }

  try {
    const { mvpdid } = getDecodedJwt(accessToken);

    return Boolean(mvpdid);
  } catch {}

  return false;
}
